import { t } from '@/features/i18n/utils';
import { WorkspaceBreadcrumbs } from '@/features/workspaces/components/workspace-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import { checklistRunsQuery } from '@/features/checklists/queries';
import { ChecklistsPage } from '@/features/checklists/components/checklists-page';
import { workspaceQuery } from '@/features/workspaces/queries';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/checklists/',
)({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const workspace = await context.queryClient.query({
      ...workspaceQuery(params.workspaceId),
      staleTime: 'static',
    });
    return context.queryClient.query({
      ...checklistRunsQuery({ documentType: workspace.type, resourceId: params.workspaceId }),
      staleTime: 'static',
    });
  },
});

function RouteComponent() {
  const { workspaceId, projectId } = Route.useParams();

  return (
    <>
      <Header>
        <HeaderBackButton
          to="/project/$projectId/workspaces/$workspaceId"
          params={{ projectId, workspaceId }}
        />
        <WorkspaceBreadcrumbs>
          <BreadcrumbPage>{t({ en: 'Checklists', nb: 'Sjekklister' })}</BreadcrumbPage>
        </WorkspaceBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <ChecklistsPage />
    </>
  );
}
